import { useModal } from "@sablier/v2-contexts";
import type { IModalChainPicker } from "@sablier/v2-types";

function useModalChainPicker<T extends IModalChainPicker = IModalChainPicker>(
  id: string,
) {
  return useModal<T>(id);
}

export default useModalChainPicker;
